import API from "@/services/api";
import { SignUpDataAPI, SignUpResponse } from "../types/signup";


enum Endpoints {
  ConfirmSignUp = '/signup/confirm',
};


export const confirmSignUp = (data: SignUpDataAPI) => {

  return API.post<SignUpResponse, SignUpDataAPI>({
    endpoint: Endpoints.ConfirmSignUp,
    versions: [1],
    data
  });
}

export default {
  confirmSignUp
};


